<!--护士-->
<template>
  <div class="dialog" @click="clickBlank">
    <div class="dialag-con">
      <div class="title" ref="tile">
        <div class="alarm-num">
          共<span>{{ dialogData.length }}</span
          >条 报警信息
        </div>
        <div class="close" @click.stop="closeDialog">X</div>
      </div>
      <div style="flex: 1;">
        <div class="con-item">
			<!-- 删除 @click="goRealPage(item)" -->
          <div
            v-for="(item, index) in dialogShowData"
            :key="index"
            class="item-bor"
            :style="{ width: 100 / dialogShowData.length + '%' }"
          >
            <div class="build-floor">
              <span>{{ item.buildName }}</span>
              &nbsp;&nbsp;-&nbsp;&nbsp;
              <span>{{ item.floorName }}</span>
            </div>
            <div class="room" :class="{ 'alarm-color': item.status == 5 }">
              {{ item.roomName }}
            </div>
            <div class="bed">{{ item.bedName }}</div>
            <div class="status">
			  <img
                v-if="item.statusName === '需要帮助' && item.status === 5"
                src="./../../../assets/icon_sos_btn_bell_7.png"
                alt=""
                srcset=""
				style="margin-top: -13px; width: 80px; height: 66px;"
              />
			  <img
                v-if="item.statusName === '需要帮助' && item.status == 6"
                src="./../../../assets/icon_sos_btn_bell_8.png"
                alt=""
                srcset=""
				style="margin-top: -13px; width: 80px; height: 66px;"
              />
              <img
                v-if="item.statusName === '已跌倒' && item.status === 5"
                src="./../../../assets/img/fallDown_red@2x.png"
                alt=""
                srcset=""
              />
              <img
                v-if="item.statusName === '已跌倒' && item.status === 6"
                src="./../../../assets/img/fallDown_grey@2x.png"
                alt=""
                srcset=""
              />
              <img
                v-if="item.statusName === '卫生间停留过久' && item.status === 5"
                src="./../../../assets/img/iconToilet_redBG@2x.png"
                alt=""
                srcset=""
              />
              <img
                v-if="item.statusName === '卫生间停留过久' && item.status === 6"
                src="./../../../assets/img/iconToilet_blackBG_large@2x.png"
                alt=""
                srcset=""
              />
              <img
                v-if="item.statusName === '离床过久' && item.status === 5"
                src="./../../../assets/img/leaveBed_red@2x.png"
                alt=""
                srcset=""
              />
              <img
                v-if="item.statusName === '离床过久' && item.status === 6"
                src="./../../../assets/img/leaveBed_grey@2x.png"
                alt=""
                srcset=""
              />
              <img
                class="breath-icon"
                v-if="
                  (item.statusName === '呼吸暂停' && item.status === 5) ||
                    (item.statusName === '呼吸过速' && item.status === 5)
                "
                src="./../../../assets/img/breath_red@2x.png"
                alt=""
                srcset=""
              />
              <img
                class="breath-icon"
                v-if="
                  (item.statusName === '呼吸暂停' && item.status === 6) ||
                    (item.statusName === '呼吸过缓' && item.status === 6)
                "
                src="./../../../assets/img/breath@2x.png"
                alt=""
                srcset=""
              />
              <img
                class="breath-icon"
                v-if="
                  (item.statusName === '心跳过速' && item.status === 5) ||
                    (item.statusName === '心跳过缓' && item.status === 5)
                "
                src="./../../../assets/img/heart@2x.png"
                alt=""
                srcset=""
              />
              <img
                class="breath-icon"
                v-if="
                  (item.statusName === '心跳过速' && item.status === 6) ||
                    (item.statusName === '心跳过缓' && item.status === 6)
                "
                src="./../../../assets/img/heart@2x(1).png"
                alt=""
                srcset=""
              />
              <span :class="{ 'alarm-color': item.status == 5  }">{{
                item.statusName === '呼吸暂停'
                  ? '呼吸暂停过久'
                  : item.statusName
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div>
          <span>{{ pageLeftText }}</span>
          /
          <span>{{ pageRightText }}</span>
        </div>
      </div>
      <div
        class="page-l"
        v-if="dialogCopyData.length > 1"
        @click.stop="changePage('reduce')"
      >
        <img
          v-if="pageFlag !== 1"
          src="./../../../assets/img/leftFlip@2x.png"
          alt=""
          srcset=""
        />
        <img
          v-else
          src="./../../../assets/img/leftFlip@2x(1).png"
          alt=""
          srcset=""
        />
      </div>
      <div
        class="page-r"
        v-if="dialogCopyData.length > 1"
        @click.stop="changePage('plus')"
      >
        <img
          v-if="pageFlag !== dialogCopyData.length"
          src="./../../../assets/img/rightFlip@2x.png"
          alt=""
          srcset=""
        />
        <img
          v-else
          src="./../../../assets/img/rightFlip(1).png"
          alt=""
          srcset=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialogData: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {
      role: 2,
      dialogCopyData: [],
      dialogShowData: [],
      pageLeftText: '01',
      pageRightText: '01',
      pageFlag: 1,
    };
  },
  created() {
    this.role = this.$getCookie('userInfo').user.roleId;
    this.changeArray();
  },
  mounted() {},
  methods: {
	clickBlank() {
		console.log('===点击了空白处===')
	},
    changeArray(arr = JSON.parse(JSON.stringify(this.dialogData)), num = 3) {
      console.log(arr);
      this.dialogCopyData = [];
      console.log(arr);
      const total = Math.ceil(arr.length / num);
      console.log(total);
      for (let i = 0; i < total; i++) {
        let res = arr.slice(i * num, (i + 1) * num);
        this.dialogCopyData.push(res);
      }
      console.log('dialogCopyData', this.dialogCopyData);
      this.dialogShowData = this.dialogCopyData[0];
      this.pageRightText =
        this.dialogCopyData.length > 9
          ? this.dialogCopyData.length
          : '0' + this.dialogCopyData.length;
    },
    changePage(flag) {
      // 切换页数
      if (flag == 'reduce') {
        this.pageFlag--;
        this.computePage(this.pageFlag);
        if (this.pageFlag < 1) {
          console.log(this.dialogCopyData.length, this.pageFlag);
          this.pageFlag = 1;
          this.dialogShowData = this.dialogCopyData[this.pageFlag - 1];
          return;
        }
        this.dialogShowData = this.dialogCopyData[this.pageFlag - 1];
      } else {
        this.pageFlag++;
        this.computePage(this.pageFlag);
        console.log(this.dialogCopyData.length, this.pageFlag);
        if (this.pageFlag > this.dialogCopyData.length) {
          this.pageFlag = this.dialogCopyData.length;
          return;
        }
        this.dialogShowData = this.dialogCopyData[this.pageFlag - 1];
      }
    },
    computePage(pageNum) {
      if (pageNum == 0) {
        pageNum = 1;
      }
      if (pageNum > this.dialogCopyData.length) {
        pageNum = this.dialogCopyData.length;
      }
      this.pageLeftText = pageNum > 9 ? pageNum : '0' + pageNum;
    },
    closeDialog() {
      this.dialogCopyData = [];
      this.dialogShowData = [];
      this.$emit('closeDialog');
    },
    goRealPage(item) {
      if (this.role == '3') {
        this.$router.push({
          path: '/protect/realTimeMonitoringtwo/?roomId=' + item.roomId,
        });
      } else if (this.role == '2') {
        this.$router.push({
          path: '/dean/realTimeMonitoringtwo/?roomId=' + item.roomId,
        });
      }
    },
  },
  watch: {
    dialogData(newData, oldData) {
      this.changeArray();
	  this.pageFlag = 1;
       this.computePage(1);
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  padding: 120px 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  .dialag-con {
    position: relative;
    width: 1280px;
    background: #ffffff;
    box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    padding: 30px 0px 0;
    display: flex;
    flex-direction: column;
    margin-top: 60px;
    z-index: 999;
    .title {
      display: flex;
      justify-content: space-between;
      text-align: center;
      font-size: 32px;
      font-weight: 400;
      color: #262626;
      padding: 0 30px;
      margin-bottom: 60px;
      span {
        color: #1890ff;
      }
      .close {
        font-size: 24px;
        color: rgba(0, 0, 0, 0.45);
        cursor: pointer;
      }
    }
    .con-item {
      flex: 1;
      padding: 0 30px;
      font-size: 38px;
      color: #262626;
      font-weight: 400;
      display: flex;
      justify-content: center;
      text-align: center;
      .item-bor {
        border-left: 1px dashed #ccc;
      }
      .item-bor:nth-of-type(1) {
        border-left: none;
      }
      .build-floor {
        margin-bottom: 35px;
      }
      .room {
        margin-bottom: 35px;
        font-size: 72px;
        font-weight: 500;
      }
      .bed {
        margin-bottom: 35px;
      }
      .status {
        font-size: 72px;
        font-weight: 500;
        img {
          width: 60px;
          height: 60px;
          margin-right: 15px;
        }
        .breath-icon {
          width: 66px;
          height: 58px;
        }
      }
      .alarm-color {
        color: #ff4d4f;
      }
    }
    .bottom {
      width: 100%;
      height: 125px;
      background: linear-gradient(180deg, #ffffff 0%, #ffcece 100%);
      border-radius: 0px 0px 8px 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #262626;
      font-size: 24px;
    }
    .page-l {
      position: absolute;
      top: 50%;
      left: 0px;
      transform: translate(-50%, -50%);
      cursor: pointer;
      img {
        width: 75px;
        height: 75px;
      }
    }
    .page-r {
      position: absolute;
      top: 50%;
      right: 0px;
      transform: translate(50%, -50%);
      cursor: pointer;
      img {
        width: 75px;
        height: 75px;
      }
    }
  }
}
</style>
